module.exports = "/_next/static/images/055b98b84c6babe19a5f46b8f425fb09-nubanker-tpm@3x.jpg.webp";